const styles = {
  page: {
    minHeight: '100vh',
    background:
      'radial-gradient(circle at 50% -10%, rgba(218,165,32,0.11), transparent 30%), radial-gradient(circle at 50% 28%, rgba(218,165,32,0.055), transparent 34%), linear-gradient(180deg, #020611 0%, #030712 48%, #02040b 100%)',
    color: '#FFD700',
    fontFamily: "'Cinzel', serif",
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '10px 14px 34px',
    position: 'relative',
    overflowX: 'hidden',
  },
  starLayer: {
    position: 'fixed',
    inset: 0,
    zIndex: 0,
    pointerEvents: 'none',
    background:
      'radial-gradient(circle, rgba(255,215,0,0.22) 0 1px, transparent 1.7px), radial-gradient(circle, rgba(255,255,255,0.08) 0 1px, transparent 1.8px)',
    backgroundSize: '34px 34px',
    backgroundPosition: '0 0, 17px 17px',
    opacity: 0.18,
    animation: 'starDrift 180s linear infinite',
  },
  navbar: {
    width: '100%',
    maxWidth: 900,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 10px',
    paddingTop: 'calc(env(safe-area-inset-top, 0px) + 8px)',
    marginBottom: 4,
    borderBottom: 'none',
    userSelect: 'none',
    position: 'sticky',
    top: 0,
    zIndex: 10,
    background: 'transparent',
    backdropFilter: 'none',
    WebkitBackdropFilter: 'none',
  },
  navButton: {
    background: 'rgba(8, 7, 22, 0.54)',
    border: '1px solid rgba(218,165,32,0.58)',
    color: '#FFD76A',
    fontWeight: 900,
    fontSize: 15,
    cursor: 'pointer',
    padding: '11px 16px',
    borderRadius: 18,
    lineHeight: 1,
    minHeight: 44,
    minWidth: 44,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    boxShadow: '0 12px 26px rgba(0,0,0,0.30)',
    touchAction: 'manipulation',
    WebkitTapHighlightColor: 'transparent',
  },
  navButtonHover: { color: '#fff' },
  navTitle: {
    fontWeight: 900,
    fontSize: 20,
    letterSpacing: 2,
    color: '#FFD700',
  },

  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: 900,
    textAlign: 'center',
    marginBottom: 20,
    padding: '8px 10px 0',
    position: 'relative',
    zIndex: 3,
  },
  title: {
    fontSize: 'clamp(40px, 8vw, 58px)',
    fontWeight: 900,
    margin: 0,
    letterSpacing: 1.8,
    color: '#F4C762',
    textShadow: '0 0 18px rgba(218,165,32,0.34)',
  },
  tagline: {
    fontSize: 'clamp(15px, 3.4vw, 20px)',
    fontWeight: 700,
    opacity: 0.92,
    marginTop: 6,
    marginBottom: 18,
    color: '#f0d79a',
    textShadow: 'none',
  },
  votesInfo: {
    width: 'min(500px, 88vw)',
    fontSize: 13,
    fontWeight: 800,
    color: '#FFD700',
    userSelect: 'none',
    padding: '13px 18px 15px',
    borderRadius: 24,
    border: '1px solid rgba(218,165,32,0.36)',
    background: 'rgba(5,7,18,0.58)',
    boxShadow: '0 16px 34px rgba(0,0,0,0.26), inset 0 1px 0 rgba(255,255,255,0.04)',
  },

  loadingContainer: {
    minHeight: '100vh',
    background: 'linear-gradient(180deg, #020611 0%, #030712 100%)',
    color: '#FFD700',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: "'Cinzel', serif",
    fontSize: 18,
  },
  loadingSpinner: {
    width: 60,
    height: 60,
    border: '6px solid rgba(255, 215, 0, 0.22)',
    borderTopColor: '#FFD700',
    borderRadius: '50%',
    animation: 'spin 1.5s linear infinite',
    marginBottom: 14,
  },
  loadingText: {
    fontWeight: 700,
    textShadow: '0 0 10px rgba(218,165,32,0.26)',
  },
  errorContainer: {
    minHeight: '100vh',
    background: 'linear-gradient(180deg, #120008 0%, #070013 100%)',
    color: '#ff7777',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: "'Cinzel', serif",
    fontSize: 18,
    padding: 20,
  },
  errorIcon: { fontSize: 48, marginBottom: 12 },
  errorMessage: {
    fontWeight: 700,
    marginBottom: 16,
    textAlign: 'center',
    maxWidth: 320,
  },
  retryBtn: {
    background: 'linear-gradient(135deg, #DAA520, #FFD700)',
    border: 'none',
    padding: '10px 20px',
    borderRadius: 30,
    fontWeight: 900,
    fontSize: 14,
    color: '#120024',
    cursor: 'pointer',
    boxShadow: '0 10px 22px rgba(0,0,0,0.28)',
  },
  retryBtnHover: { transform: 'scale(1.05)' },

  noClashSection: {
    maxWidth: 720,
    textAlign: 'center',
    marginTop: 34,
    padding: '20px 16px',
    background: 'rgba(5,7,18,0.52)',
    borderRadius: 24,
    border: '1px solid rgba(218,165,32,0.24)',
    boxShadow: '0 16px 34px rgba(0,0,0,0.24)',
    userSelect: 'none',
  },
  noClashMessage: {
    fontSize: 18,
    fontWeight: 700,
    marginBottom: 20,
  },
  resultsContainer: {
    marginTop: 12,
    paddingTop: 12,
    borderTop: '1px solid rgba(255, 255, 255, 0.10)',
    maxHeight: 220,
    overflowY: 'auto',
  },
  resultsTitle: {
    fontWeight: 900,
    fontSize: 20,
    color: '#FFD700',
    marginBottom: 14,
  },
  resultRow: {
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 700,
    fontSize: 14,
    padding: '6px 12px',
    borderBottom: '1px solid rgba(255, 215, 0, 0.12)',
    color: '#fff',
    letterSpacing: 0.5,
  },
  resultSign: { flex: 1, textTransform: 'capitalize' },
  resultVs: { flex: 0.3, textAlign: 'center', opacity: 0.7 },
  resultPercent: {
    flex: 1,
    textAlign: 'right',
    color: '#FFD700',
    fontWeight: 900,
    letterSpacing: 1,
  },

  clashSection: {
    maxWidth: 920,
    width: '100%',
    textAlign: 'center',
    position: 'relative',
    zIndex: 3,
  },
  question: {
    position: 'relative',
    width: 'min(680px, 100%)',
    margin: '2px auto 12px',
    padding: '22px 24px',
    borderRadius: 24,
    background:
      'linear-gradient(180deg, rgba(8,10,24,0.84), rgba(5,7,18,0.70))',
    border: '1px solid rgba(218,165,32,0.42)',
    boxShadow:
      '0 18px 38px rgba(0,0,0,0.28), inset 0 1px 0 rgba(255,255,255,0.04)',
    color: '#F8DFA0',
    fontSize: 'clamp(22px, 5vw, 31px)',
    fontWeight: 900,
    lineHeight: 1.28,
    textAlign: 'center',
    letterSpacing: -0.25,
    boxSizing: 'border-box',
    animation: 'none',
  },
  clashContext: {
    width: 'fit-content',
    maxWidth: 'min(700px, 100%)',
    margin: '0 auto 24px',
    padding: '9px 14px',
    borderRadius: 999,
    border: '1px solid rgba(218,165,32,0.18)',
    background: 'rgba(218,165,32,0.055)',
    fontSize: 'clamp(12px, 2.7vw, 15px)',
    fontWeight: 800,
    lineHeight: 1.35,
    color: 'rgba(255,226,160,0.86)',
    textAlign: 'center',
    pointerEvents: 'none',
    boxSizing: 'border-box',
  },

  cardsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'stretch',
    gap: 44,
    flexWrap: 'nowrap',
    marginTop: 20,
  },
  card: {
    background: 'rgba(5,7,18,0.58)',
    borderRadius: 30,
    border: '1.5px solid rgba(218,165,32,0.48)',
    width: 320,
    minHeight: 318,
    flexShrink: 0,
    boxSizing: 'border-box',
    color: '#FFD700',
    fontWeight: 900,
    boxShadow: '0 18px 44px rgba(0,0,0,0.36), inset 0 1px 0 rgba(255,255,255,0.04)',
    transition: 'transform .24s ease, box-shadow .24s ease, filter .24s ease, border-color .24s ease',
    animation: 'none',
    position: 'relative',
    overflow: 'hidden',
    backdropFilter: 'none',
    WebkitBackdropFilter: 'none',
  },
  cardInner: {
    width: '100%',
    height: '100%',
    padding: '24px 18px 22px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',
    zIndex: 1,
  },
  signWatermark: {
    position: 'absolute',
    right: -8,
    top: '22%',
    fontSize: 126,
    lineHeight: 1,
    opacity: 0.10,
    filter: 'none',
    pointerEvents: 'none',
    userSelect: 'none',
    zIndex: 0,
  },
  cardAura: {
    position: 'absolute',
    inset: '0 0 auto 0',
    height: '54%',
    pointerEvents: 'none',
    filter: 'blur(12px)',
    opacity: 0.28,
    animation: 'none',
    zIndex: 0,
  },
  elementPill: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    padding: '8px 15px',
    borderRadius: 18,
    border: '1px solid rgba(218,165,32,0.28)',
    background: 'rgba(0,0,0,0.20)',
    fontSize: 13,
    fontWeight: 900,
    letterSpacing: 0.4,
    marginBottom: 12,
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.06)',
  },
  cardHover: {
    transform: 'scale(1.025)',
    boxShadow: '0 20px 46px rgba(0,0,0,0.38), 0 0 20px rgba(218,165,32,0.16)',
  },
  signSymbol: {
    fontSize: 74,
    lineHeight: 1,
    filter: 'drop-shadow(0 0 7px rgba(255, 215, 0, 0.32))',
    userSelect: 'none',
  },
  signName: {
    fontSize: 'clamp(22px, 4vw, 30px)',
    fontWeight: 900,
    textShadow: 'none',
    marginBottom: 10,
    letterSpacing: -0.35,
    color: '#fff6dc',
    width: '100%',
    textAlign: 'center',
    lineHeight: 1.06,
    whiteSpace: 'nowrap',
    overflow: 'visible',
    textOverflow: 'clip',
    display: 'block',
  },
  signEmoji: {
    marginTop: 2,
    marginBottom: 10,
    fontSize: 54,
    lineHeight: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#FFD700',
    textShadow: '0 0 12px rgba(255,215,0,0.45)',
    filter: 'drop-shadow(0 0 5px rgba(0,0,0,0.45))',
    userSelect: 'none',
    pointerEvents: 'none',
  },
  percentBarContainer: {
    width: '64%',
    height: 40,
    background: 'rgba(0,0,0,0.16)',
    borderRadius: 999,
    marginTop: 12,
    overflow: 'hidden',
    border: '1px solid rgba(255,255,255,0.09)',
    boxShadow: 'inset 0 1px 8px rgba(0,0,0,0.24)',
  },
  percentBar: {
    height: '100%',
    borderRadius: 999,
    transition: 'width 0.6s ease, opacity 0.35s ease',
    boxShadow: '0 0 12px currentColor',
  },
  percentText: {
    fontSize: 20,
    fontWeight: 900,
    color: '#FFD700',
    textShadow: '0 0 10px rgba(218,165,32,0.36)',
  },
  cardTagline: {
    marginTop: 12,
    fontSize: 14,
    fontWeight: 600,
    fontStyle: 'italic',
    color: '#e6c77a',
    userSelect: 'none',
  },

  vsWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
    marginTop: 120,
    marginBottom: 0,
  },
  vsLine: {
    width: 52,
    height: 2,
    background: 'linear-gradient(90deg, transparent, rgba(255,215,0,0.72), transparent)',
    boxShadow: '0 0 8px rgba(218,165,32,0.24)',
  },
  vsText: {
    width: 50,
    height: 50,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 25,
    fontWeight: 900,
    color: '#FFD700',
    border: '1px solid rgba(218,165,32,0.44)',
    background: 'rgba(5,7,18,0.92)',
    boxShadow:
      '0 0 20px rgba(218,165,32,0.18), 0 12px 24px rgba(0,0,0,0.24)',
    textShadow: '0 0 10px rgba(218,165,32,0.34)',
  },

  cosmicGlow: {
    position: 'fixed',
    inset: 0,
    pointerEvents: 'none',
    background:
      'radial-gradient(circle at 50% 20%, rgba(218,165,32,0.09), transparent 38%), radial-gradient(circle at 50% 48%, rgba(218,165,32,0.055), transparent 28%)',
    zIndex: 1,
    animation: 'none',
  },
  auroraLayer: {
    position: 'fixed',
    inset: 0,
    pointerEvents: 'none',
    zIndex: 2,
    background:
      'radial-gradient(circle at 50% 20%, rgba(218,165,32,0.045), transparent 34%)',
    opacity: 1,
    filter: 'none',
    mixBlendMode: 'normal',
    animation: 'none',
  },

  lockedFooter: {
    marginTop: 40,
    fontSize: 16,
    fontWeight: 700,
    color: '#ff7777',
    textAlign: 'center',
    userSelect: 'none',
  },
  ritualOrbs: {
    display: 'flex',
    justifyContent: 'center',
    gap: 22,
    marginTop: 11,
    marginBottom: 11,
  },
  orb: {
    width: 15,
    height: 15,
    borderRadius: '50%',
    background: 'radial-gradient(circle, #FFD700 0%, #DAA520 48%, rgba(218,165,32,0.18) 100%)',
    boxShadow: '0 0 14px rgba(218,165,32,0.62)',
  },
  votesCount: {
    marginTop: 2,
    fontSize: 13,
    opacity: 0.95,
  },

  metaStripRow: {
  width: '100%',
  maxWidth: 900,
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: 12,
  marginTop: 18,
},
  metaStripCard: {
    minWidth: 0,
    padding: '20px 16px',
    borderRadius: 22,
    background: 'rgba(5,7,18,0.58)',
    border: '1px solid rgba(218,165,32,0.28)',
    boxShadow: '0 16px 34px rgba(0,0,0,0.24)',
    textAlign: 'center',
  },
  metaStripLabel: {
    fontSize: 12,
    fontWeight: 900,
    letterSpacing: 0.9,
    textTransform: 'uppercase',
    color: 'rgba(255,215,0,0.84)',
    marginBottom: 8,
  },
  metaStripValue: {
    fontSize: 22,
    fontWeight: 900,
    color: '#FFF1B0',
    lineHeight: 1.2,
    minHeight: 22,
  },
  metaStripSub: {
    marginTop: 7,
    fontSize: 14,
    lineHeight: 1.45,
    color: 'rgba(255,233,166,0.82)',
    fontWeight: 700,
  },

  resultNarrativeCard: {
    maxWidth: 640,
    margin: '20px auto 0',
    padding: '20px 18px 18px',
    borderRadius: 24,
    border: '1px solid rgba(218,165,32,0.28)',
    background:
      'linear-gradient(180deg, rgba(8,10,24,0.82), rgba(5,7,18,0.68))',
    boxShadow:
      '0 18px 40px rgba(0,0,0,0.28), inset 0 1px 0 rgba(255,255,255,0.035)',
    boxSizing: 'border-box',
    overflow: 'hidden',
  },
  resultNarrativeTitle: {
    fontSize: 12,
    fontWeight: 900,
    letterSpacing: 0.8,
    textTransform: 'uppercase',
    color: 'rgba(255,215,0,0.82)',
    marginBottom: 7,
  },
  resultNarrativeText: {
    fontSize: 14,
    lineHeight: 1.55,
    color: '#FFF1B0',
    fontWeight: 750,
  },
  predictionResult: {
    marginTop: 12,
    padding: '10px 12px',
    borderRadius: 14,
    fontSize: 12,
    lineHeight: 1.45,
    fontWeight: 900,
  },
  predictionResultHit: {
    background: 'rgba(218,165,32,0.14)',
    border: '1px solid rgba(218,165,32,0.30)',
    color: '#FFE9A6',
  },
  predictionResultMiss: {
    background: 'rgba(255,255,255,0.045)',
    border: '1px solid rgba(255,255,255,0.10)',
    color: '#F3E7FF',
  },

  emotionalFeedback: {
    marginTop: 28,
    maxWidth: 520,
    padding: '14px 22px',
    borderRadius: 30,
    fontSize: 16,
    fontWeight: 700,
    color: '#FFD700',
    background: 'rgba(5,7,18,0.58)',
    border: '1px solid rgba(218,165,32,0.22)',
    boxShadow: '0 14px 30px rgba(0,0,0,0.22)',
    textAlign: 'center',
    animation: 'none',
    userSelect: 'none',
  },
  toast: {
    position: 'fixed',
    left: '50%',
    bottom: 'calc(env(safe-area-inset-bottom, 0px) + 16px)',
    transform: 'translateX(-50%)',
    zIndex: 50,
    maxWidth: 560,
    width: 'calc(100% - 28px)',
    padding: '12px 14px',
    borderRadius: 18,
    boxShadow: '0 18px 40px rgba(0,0,0,0.34)',
    animation: 'toastPop 2.8s ease both',
    pointerEvents: 'none',
  },
  toastGold: {
    background: 'linear-gradient(135deg, rgba(218,165,32,0.96), rgba(255,215,0,0.92))',
    border: '1px solid rgba(255,215,0,0.45)',
    color: '#120024',
  },
  toastViolet: {
    background: 'linear-gradient(135deg, rgba(25,0,54,0.96), rgba(218,165,32,0.80))',
    border: '1px solid rgba(218,165,32,0.30)',
    color: '#FFD700',
  },
  toastRow: { display: 'flex', alignItems: 'center', gap: 12 },
  toastIcon: {
    width: 38,
    height: 38,
    borderRadius: 14,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 20,
    fontWeight: 900,
    background: 'rgba(0,0,0,0.20)',
    border: '1px solid rgba(255,255,255,0.16)',
    boxShadow: '0 8px 18px rgba(0,0,0,0.20)',
    flex: '0 0 auto',
  },
  toastTextWrap: { textAlign: 'left', lineHeight: 1.15, minWidth: 0 },
  toastLabel: {
    color: 'inherit',
    fontSize: 11,
    fontWeight: 900,
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    opacity: 0.85,
    marginBottom: 2,
  },
  toastText: {
    color: 'inherit',
    fontSize: 14,
    fontWeight: 900,
    letterSpacing: 0.1,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },

  dominionWrap: {
    width: '100%',
    maxWidth: 900,
    margin: '22px auto 0',
    position: 'relative',
    zIndex: 4,
  },
  dominionBtn: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
    padding: '17px 20px',
    borderRadius: 24,
    border: '1px solid rgba(218,165,32,0.32)',
    background: 'rgba(5,7,18,0.58)',
    color: '#FFD700',
    boxShadow: '0 16px 34px rgba(0,0,0,0.24)',
    cursor: 'pointer',
    userSelect: 'none',
  },
  dominionBtnOpen: {
    border: '1px solid rgba(218,165,32,0.42)',
  },
  dominionBtnLeft: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 10,
    minWidth: 0,
  },
  dominionCrown: { fontSize: 23, lineHeight: 1 },
  dominionBtnTitle: {
    fontWeight: 900,
    letterSpacing: 0.4,
  },
  dominionBtnSub: {
    fontSize: 14,
    fontWeight: 800,
    opacity: 0.85,
    color: '#e6c77a',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  dominionChevron: { fontSize: 18, opacity: 0.9 },
  dominionPanel: {
    marginTop: 10,
    padding: '16px 16px 14px',
    borderRadius: 22,
    border: '1px solid rgba(255,255,255,0.10)',
    background: 'rgba(5,7,18,0.60)',
    boxShadow: '0 20px 42px rgba(0,0,0,0.28)',
    overflow: 'hidden',
  },
  dominionTopRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
    marginBottom: 12,
  },
  dominionMeta: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    minWidth: 0,
  },
  dominionMetaTitle: {
    fontSize: 15,
    fontWeight: 900,
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    opacity: 0.95,
  },
  dominionPills: { display: 'flex', gap: 8, flexWrap: 'wrap' },
  dominionPill: {
    padding: '9px 13px',
    borderRadius: 999,
    border: '1px solid rgba(218,165,32,0.22)',
    background: 'rgba(0,0,0,0.18)',
    color: '#FFD700',
    fontWeight: 900,
    fontSize: 14,
    cursor: 'pointer',
  },
  dominionPillActive: {
    background: 'rgba(218,165,32,0.14)',
    border: '1px solid rgba(218,165,32,0.42)',
  },
  dominionRefresh: {
    width: 42,
    height: 42,
    borderRadius: 14,
    border: '1px solid rgba(255,255,255,0.12)',
    background: 'rgba(0,0,0,0.20)',
    color: '#FFD700',
    fontWeight: 900,
    cursor: 'pointer',
  },
  dominionState: {
    padding: '10px 8px 12px',
    fontSize: 14,
    fontWeight: 900,
    color: '#FFD700',
    opacity: 0.9,
  },
  dominionList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    gap: 10,
    alignItems: 'stretch',
  },
  dominionRow: {
    display: 'grid',
    gridTemplateColumns: '28px 1fr',
    alignItems: 'center',
    gap: 8,
    padding: '12px 12px',
    borderRadius: 16,
    border: '1px solid rgba(255,255,255,0.09)',
    background: 'rgba(255,255,255,0.035)',
    boxShadow: '0 10px 24px rgba(0,0,0,0.18)',
    minWidth: 0,
    overflow: 'hidden',
  },
  dominionRowTop1: {
    border: '1px solid rgba(218,165,32,0.28)',
    background: 'rgba(218,165,32,0.08)',
  },
  dominionRowTop2: {
    border: '1px solid rgba(255,255,255,0.14)',
  },
  dominionRowTop3: {
    border: '1px solid rgba(218,165,32,0.14)',
  },
  dominionRankMain: {
    fontWeight: 900,
    color: '#FFD700',
    fontSize: 24,
    lineHeight: 1,
  },
  dominionRankTop1: { color: '#FFD700' },
  dominionTie: {
    marginTop: 3,
    fontSize: 10,
    fontWeight: 900,
    opacity: 0.78,
    color: '#cbb37a',
  },
  dominionTopBadge: {
    marginLeft: 8,
    padding: '4px 7px',
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 900,
    lineHeight: 1,
    border: '1px solid rgba(255,255,255,0.12)',
    background: 'rgba(0,0,0,0.20)',
    flex: '0 0 auto',
  },
  dominionTopBadge1: {
    border: '1px solid rgba(218,165,32,0.28)',
    background: 'rgba(218,165,32,0.14)',
  },
  dominionTopBadge2: {
    border: '1px solid rgba(255,255,255,0.18)',
    background: 'rgba(255,255,255,0.08)',
  },
  dominionTopBadge3: {
    border: '1px solid rgba(218,165,32,0.18)',
    background: 'rgba(255,255,255,0.055)',
  },
  dominionRank: {
    fontWeight: 900,
    color: '#e6c77a',
    fontSize: 12,
    opacity: 0.95,
  },
  dominionSign: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    minWidth: 0,
  },
  dominionEmoji: {
    fontSize: 24,
    lineHeight: 1,
    filter: 'drop-shadow(0 0 8px rgba(218,165,32,0.18))',
  },
  dominionLabel: {
    fontWeight: 900,
    color: 'rgba(255,255,255,0.96)',
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: 0,
  },
  dominionText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    minWidth: 0,
    gap: 2,
  },
  dominionSubline: {
    fontSize: 11,
    fontWeight: 900,
    color: 'rgba(255,215,0,0.78)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  dominionBarOuter: {
    gridColumn: '1 / -1',
    height: 7,
    borderRadius: 999,
    background: 'rgba(218,165,32,0.12)',
    overflow: 'hidden',
    border: '1px solid rgba(218,165,32,0.12)',
  },
  dominionBarInner: {
    height: '100%',
    borderRadius: 999,
    background: 'linear-gradient(90deg, rgba(218,165,32,0.88), rgba(255,215,0,0.70))',
    transformOrigin: 'left center',
    transition: 'transform 650ms cubic-bezier(0.2, 0.9, 0.2, 1)',
  },
  dominionPct: {
    textAlign: 'right',
    fontWeight: 900,
    color: '#FFD700',
  },
  dominionFooter: {
    marginTop: 10,
    paddingTop: 10,
    borderTop: '1px solid rgba(255,255,255,0.10)',
    fontSize: 12,
    fontWeight: 800,
    color: '#e6c77a',
    display: 'flex',
    justifyContent: 'space-between',
    gap: 10,
    flexWrap: 'wrap',
  },
  dominionRowMobile: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    padding: '12px 12px',
    borderRadius: 18,
    border: '1px solid rgba(255,255,255,0.09)',
    background: 'rgba(255,255,255,0.035)',
    boxShadow: '0 10px 24px rgba(0,0,0,0.18)',
  },
  dominionRowMobileTop: {
    display: 'grid',
    gridTemplateColumns: '46px 1fr 44px',
    alignItems: 'center',
    gap: 10,
    minWidth: 0,
  },
  dominionSignMobile: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    minWidth: 0,
  },

  predictionCompactPanel: {
    marginTop: 18,
    padding: '16px 18px 17px',
    borderRadius: 24,
    background: 'rgba(5,7,18,0.58)',
    border: '1px solid rgba(218,165,32,0.30)',
    boxShadow: '0 16px 34px rgba(0,0,0,0.24)',
    textAlign: 'center',
  },
  predictionCompactHeader: { marginBottom: 12 },
  predictionCompactTitle: {
    fontSize: 16,
    fontWeight: 900,
    letterSpacing: 1.2,
    textTransform: 'uppercase',
    color: 'rgba(255,215,0,0.92)',
  },
  predictionCompactHint: {
    marginTop: 5,
    fontSize: 15,
    lineHeight: 1.35,
    color: 'rgba(255,233,166,0.86)',
    fontWeight: 700,
  },
  predictionCompactChoices: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 26,
    maxWidth: 720,
    margin: '0 auto',
  },
  predictionCompactChoice: {
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    minHeight: 50,
    padding: '10px 12px',
    borderRadius: 999,
    border: '1px solid rgba(218,165,32,0.28)',
    background: 'rgba(255,255,255,0.035)',
    color: '#FFF1B0',
    fontSize: 20,
    fontWeight: 900,
    cursor: 'pointer',
    boxShadow: '0 8px 18px rgba(0,0,0,0.16)',
    transition: 'transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease, background 160ms ease',
  },
  predictionCompactChoiceActive: {
    border: '1px solid rgba(255,215,0,0.46)',
    background: 'rgba(218,165,32,0.14)',
    boxShadow: '0 0 18px rgba(218,165,32,0.16), 0 12px 24px rgba(0,0,0,0.20)',
    color: '#FFFFFF',
  },
  predictionCompactChoicePulse: {
    animation: 'predictionChoicePulse 520ms ease-out',
  },
  predictionCompactHalo: {
    position: 'absolute',
    inset: -6,
    borderRadius: 18,
    pointerEvents: 'none',
    background: 'radial-gradient(circle at center, rgba(218,165,32,0.18), transparent 70%)',
    animation: 'predictionHalo 1.8s ease-in-out infinite',
  },
  predictionCompactEmoji: {
    position: 'relative',
    zIndex: 1,
    fontSize: 22,
    lineHeight: 1,
    filter: 'drop-shadow(0 0 5px rgba(218,165,32,0.22))',
  },
  predictionCompactLabel: {
    position: 'relative',
    zIndex: 1,
    whiteSpace: 'nowrap',
  },
  predictionCompactCheck: {
    position: 'relative',
    zIndex: 1,
    color: '#FFD700',
    textShadow: '0 0 8px rgba(218,165,32,0.42)',
    fontSize: 13,
  },
  predictionCompactFooter: {
    marginTop: 14,
    minHeight: 18,
    fontSize: 15,
    lineHeight: 1.35,
    color: 'rgba(255,233,166,0.78)',
    fontWeight: 800,
  },
  roundHeader: {
    width: 'min(680px, 100%)',
    margin: '0 auto 14px',
    padding: '14px 16px 15px',
    borderRadius: 22,
    border: '1px solid rgba(218,165,32,0.24)',
    background:
      'linear-gradient(180deg, rgba(8,10,24,0.74), rgba(5,7,18,0.58))',
    boxShadow:
      '0 14px 32px rgba(0,0,0,0.24), inset 0 1px 0 rgba(255,255,255,0.035)',
    boxSizing: 'border-box',
    textAlign: 'left',
  },
  roundHeaderDecisive: {
    border: '1px solid rgba(255,215,0,0.44)',
    background:
      'linear-gradient(135deg, rgba(218,165,32,0.13), rgba(8,10,24,0.76))',
    boxShadow:
      '0 16px 36px rgba(0,0,0,0.28), 0 0 20px rgba(218,165,32,0.09)',
  },
  roundHeaderTop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    marginBottom: 10,
  },
  roundEyebrow: {
    color: '#F3C96B',
    fontSize: 12,
    fontWeight: 900,
    letterSpacing: 1,
    textTransform: 'uppercase',
  },
  roundCounter: {
    minWidth: 42,
    padding: '5px 9px',
    borderRadius: 999,
    border: '1px solid rgba(218,165,32,0.22)',
    background: 'rgba(218,165,32,0.08)',
    color: '#FFF1B0',
    fontSize: 12,
    fontWeight: 900,
    textAlign: 'center',
  },
  roundProgressTrack: {
    width: '100%',
    height: 6,
    borderRadius: 999,
    overflow: 'hidden',
    background: 'rgba(255,255,255,0.055)',
    border: '1px solid rgba(255,255,255,0.045)',
  },
  roundProgressFill: {
    height: '100%',
    borderRadius: 999,
    background: 'linear-gradient(90deg, #DAA520, #FFD700)',
    boxShadow: '0 0 12px rgba(218,165,32,0.30)',
    transition: 'width 420ms ease',
  },
  roundHeaderHint: {
    marginTop: 9,
    color: 'rgba(255,233,166,0.76)',
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 1.4,
  },

  nextDuelButton: {
    marginTop: 16,
    width: 'min(360px, 100%)',
    minHeight: 50,
    borderRadius: 999,
    border: '1px solid rgba(218,165,32,0.58)',
    background: 'linear-gradient(135deg, #DAA520, #FFD700)',
    color: '#120024',
    fontWeight: 900,
    fontSize: 15,
    letterSpacing: 0.2,
    cursor: 'pointer',
    boxShadow:
      '0 14px 30px rgba(0,0,0,0.28), 0 0 18px rgba(218,165,32,0.16)',
    transition: 'transform .18s ease, box-shadow .18s ease',
    touchAction: 'manipulation',
  },

  clashSummaryCard: {
    width: '100%',
    maxWidth: 760,
    margin: '16px auto 0',
    padding: '20px 18px',
    borderRadius: 24,
    border: '1px solid rgba(218,165,32,0.30)',
    background: 'rgba(5,7,18,0.62)',
    boxShadow: '0 18px 38px rgba(0,0,0,0.26)',
    boxSizing: 'border-box',
    textAlign: 'center',
  },
  clashSummaryEyebrow: {
    fontSize: 12,
    fontWeight: 900,
    letterSpacing: 1,
    textTransform: 'uppercase',
    color: '#F3C96B',
    marginBottom: 8,
  },
  clashSummaryTitle: {
    fontSize: 22,
    fontWeight: 900,
    color: '#FFF1B0',
    marginBottom: 8,
  },
  clashSummaryText: {
    fontSize: 14,
    lineHeight: 1.5,
    color: 'rgba(255,233,166,0.82)',
    fontWeight: 700,
  },
  clashSummaryGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: 10,
    marginTop: 16,
  },
  clashSummaryStat: {
    padding: '12px 10px',
    borderRadius: 16,
    border: '1px solid rgba(255,255,255,0.08)',
    background: 'rgba(255,255,255,0.035)',
  },
  clashSummaryStatLabel: {
    display: 'block',
    fontSize: 11,
    fontWeight: 900,
    textTransform: 'uppercase',
    color: 'rgba(255,215,0,0.72)',
    marginBottom: 5,
  },
  clashSummaryStatValue: {
    display: 'block',
    fontSize: 18,
    fontWeight: 900,
    color: '#FFFFFF',
  },
  clashSummaryAffinity: {
    marginTop: 14,
    fontSize: 13,
    fontWeight: 800,
    color: '#E6C77A',
  },
  clashSummaryCountdown: {
    marginTop: 15,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 7,
    fontSize: 13,
    fontWeight: 900,
    color: '#FFD700',
  },
  dominionExpandButton: {
    width: '100%',
    marginTop: 12,
    minHeight: 44,
    borderRadius: 16,
    border: '1px solid rgba(218,165,32,0.30)',
    background: 'rgba(218,165,32,0.08)',
    color: '#FFD700',
    fontWeight: 900,
    fontSize: 13,
    cursor: 'pointer',
    touchAction: 'manipulation',
  },

  resultNarrativeEyebrow: {
    fontSize: 11,
    fontWeight: 900,
    letterSpacing: 1.2,
    textTransform: 'uppercase',
    color: 'rgba(255,215,0,0.72)',
    marginBottom: 7,
  },
  resultWinnerTitle: {
    fontSize: 'clamp(21px, 4.8vw, 29px)',
    fontWeight: 900,
    lineHeight: 1.18,
    color: '#FFF4C6',
    marginBottom: 12,
  },
  resultPercentRow: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'center',
    gap: 8,
    marginBottom: 9,
  },
  resultWinnerPercent: {
    fontSize: 'clamp(34px, 8vw, 48px)',
    lineHeight: 1,
    color: '#FFD700',
    fontWeight: 900,
    textShadow: '0 0 18px rgba(218,165,32,0.24)',
  },
  resultPercentCaption: {
    fontSize: 12,
    fontWeight: 800,
    color: 'rgba(255,233,166,0.72)',
  },
  resultProgressTrack: {
    width: '100%',
    height: 9,
    borderRadius: 999,
    overflow: 'hidden',
    background: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.05)',
    marginBottom: 13,
  },
  resultProgressFill: {
    height: '100%',
    borderRadius: 999,
    background: 'linear-gradient(90deg, #DAA520, #FFD700)',
    boxShadow: '0 0 14px rgba(218,165,32,0.28)',
  },
  resultCommunityBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 36,
    padding: '8px 12px',
    borderRadius: 999,
    fontSize: 12,
    lineHeight: 1.35,
    fontWeight: 900,
    boxSizing: 'border-box',
  },
  resultCommunityBadgeHit: {
    color: '#FFF1B0',
    border: '1px solid rgba(218,165,32,0.34)',
    background: 'rgba(218,165,32,0.12)',
  },
  resultCommunityBadgeMinority: {
    color: '#EDE3FF',
    border: '1px solid rgba(180,150,255,0.22)',
    background: 'rgba(120,80,220,0.10)',
  },
  resultNarrativeDivider: {
    width: '100%',
    height: 1,
    margin: '16px 0 13px',
    background:
      'linear-gradient(90deg, transparent, rgba(218,165,32,0.22), transparent)',
  },

};

export default styles;
